
<router-outlet></router-outlet>
<ngx-loading-bar height="5px"></ngx-loading-bar>